export const getAssociationsTitle = (samplingType?: string) =>
  `Your ${samplingType === 'vaginal' ? 'vaginal' : 'gut'} microbiome associations`;

export const FLAGS_PRESENT_LABEL = 'Flags present in this condition';
export const FLAGS_NOT_PRESENT_LABEL = 'Flags not present';

export const NO_FLAGS_TITLE = 'No flags present.';
export const NO_FLAGS_SUBTEXT =
  'If you are experiencing symptoms, consider exploring other potential influences, such as sleep, stress, environmental exposure, physical activity, and diet.';
export const NO_FLAGS_MARKED_SUBTEXT =
  'While the answers may not be here, our clinicians may be able to identify other areas in your report that may provide some answers for you.';
export const NO_FLAGS_MARKED_HIDE_CONSULTS_SUBTEXT =
  'While the answers may not be here, your practitioner may be able to identify other areas in your report that may provide some answers to you.';
export const SCHEDULE_CALL_LABEL = 'Schedule a call';
export const NO_NON_FLAGGED_TEXT = 'No metrics without flags.';

export const HOW_TO_USE_TITLE = 'How to use this';
export const DIVE_DEEPER_TITLE = 'Dive deeper with AI';
export const HOW_TO_USE_BODY =
  'Explore flagged metrics to learn more about how you can improve them. Your action plan has prioritized steps to address imbalances.';
export const VIEW_ACTION_PLAN_LABEL = 'View Action Plan';

export const getConditionIntro = (conditionName: string) =>
  `These metrics are commonly associated with ${conditionName}. Your results offer clues about how your microbiome could be contributing to any symptoms you may be experiencing. Other factors — including lifestyle, environment, diet, and genetics — may also play a role and should be investigated in the context of your overall health. `;

export const CONDITION_INTRO_NOTE = 'Note: this is not a diagnosis.';
